module.exports = __webpack_public_path__ + "images/1-sim-front.5531652e2c33947db751db5633e9667e.png";